module.exports = __webpack_public_path__ + "img/UTGREA-1.3681a428.jpg";